import Highcharts from 'highcharts';
import HighchartsAccessibility from 'highcharts/modules/accessibility';

export default class ChartIRSituation {
  static exec() {
    const els = document.querySelectorAll(
      '.highcharts-wrapper_en-ir-highlights'
    );
    els.forEach(function (el) {
      new ChartIRSituation(el);
    });
  }
  constructor(element) {
    const chartEl = element.querySelectorAll(
      '.highcharts-figure_en-ir-highlights'
    );

    chartEl.forEach(function (el) {
      const chartData = JSON.parse(el.getAttribute('data-chart'));
      const minValue = Math.min(
        ...chartData[1].data.filter((value) => !isNaN(value))
      );

      Highcharts.chart(el.querySelector('figure'), {
        chart: {
          type: 'column',
        },
        title: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: [
            'FY2020',
            'FY2021',
            'FY2022',
            'FY2023',
            'FY2024',
            'FY2025(FCST)',
          ],
          crosshair: true,
          accessibility: {
            description: 'years',
          },
        },
        yAxis: {
          min: minValue,
          labels: {
            formatter: function () {
              return Highcharts.numberFormat(this.value, 0, '.', ',');
            },
          },
          title: {
            text: '',
          },
        },
        tooltip: {
          valueSuffix: '',
          formatter: function () {
            return (
              this.x +
              '<br/>' +
              '<span style="color:' +
              this.series.color +
              '">\u25CF</span> ' +
              this.series.name +
              ': <b>' +
              Highcharts.numberFormat(this.y, 0, '.', ',') +
              '</b>'
            );
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: chartData,
        colors: ['#005bac', '#4fafed'],
      });

      const detailsDiv = el.querySelector('.detail tbody');

      chartData.forEach((series) => {
        let row = `<tr><th>${series.name}</th>`;
        series.data.forEach((dataPoint, index) => {
          if (typeof dataPoint === 'number') {
            dataPoint = Highcharts.numberFormat(dataPoint, 0, '.', ',');
          }
          row += `<td>${dataPoint}</td>`;
        });
        row += '</tr>';
        detailsDiv.innerHTML += row;
      });
    });
  }
}
